function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 5,
  y: 5,
  width: 30,
  height: 30
}, /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 30,
  height: 30,
  fill: "#C4C4C4"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-2 25L1.45651 27.0739C2.40656 27.6439 3.59344 27.6439 4.54349 27.0739L6.45651 25.9261C7.40656 25.3561 8.59344 25.3561 9.54349 25.9261L11.4565 27.0739C12.4066 27.6439 13.5934 27.6439 14.5435 27.0739L16.4565 25.9261C17.4066 25.3561 18.5934 25.3561 19.5435 25.9261L21.4565 27.0739C22.4066 27.6439 23.5934 27.6439 24.5435 27.0739L26.4565 25.9261C27.4066 25.3561 28.5934 25.3561 29.5435 25.9261L31.4565 27.0739C32.4066 27.6439 33.5934 27.6439 34.5435 27.0739L38 25",
  stroke: "#999999",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M-2 18L1.45651 20.0739C2.40656 20.6439 3.59344 20.6439 4.54349 20.0739L6.45651 18.9261C7.40656 18.3561 8.59344 18.3561 9.54349 18.9261L11.4565 20.0739C12.4066 20.6439 13.5934 20.6439 14.5435 20.0739L16.4565 18.9261C17.4066 18.3561 18.5934 18.3561 19.5435 18.9261L21.4565 20.0739C22.4066 20.6439 23.5934 20.6439 24.5435 20.0739L26.4565 18.9261C27.4066 18.3561 28.5934 18.3561 29.5435 18.9261L31.4565 20.0739C32.4066 20.6439 33.5934 20.6439 34.5435 20.0739L38 18",
  stroke: "#999999",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M-2 11L1.45651 13.0739C2.40656 13.6439 3.59344 13.6439 4.54349 13.0739L6.45651 11.9261C7.40656 11.3561 8.59344 11.3561 9.54349 11.9261L11.4565 13.0739C12.4066 13.6439 13.5934 13.6439 14.5435 13.0739L16.4565 11.9261C17.4066 11.3561 18.5934 11.3561 19.5435 11.9261L21.4565 13.0739C22.4066 13.6439 23.5934 13.6439 24.5435 13.0739L26.4565 11.9261C27.4066 11.3561 28.5934 11.3561 29.5435 11.9261L31.4565 13.0739C32.4066 13.6439 33.5934 13.6439 34.5435 13.0739L38 11",
  stroke: "#999999",
  strokeWidth: 2
}));

var SvgFoggy = function SvgFoggy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoggy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/foggy.90453419.svg";
export { ForwardRef as ReactComponent };